import type { BaseSlideProps, SynthesisContent } from './SlideLayout.types';
import { inlineMarkdown } from '@/lib/markdown';

export function SynthesisSlide({ title, content, accentColor }: BaseSlideProps) {
  const { keyTakeaways, bridgeText } = content as SynthesisContent;

  return (
    <div
      className="slide-content animate-fade-in-up"
      style={{ '--color-accent': accentColor } as React.CSSProperties}
    >
      <h2 className="text-4xl font-serif font-bold mb-8 text-center accent-text">
        {title}
      </h2>

      <div className="max-w-3xl mx-auto">
        {/* Key Takeaways */}
        <div className="mb-8">
          <h3 className="text-xl font-serif font-semibold mb-6 text-slate-700 dark:text-slate-300">
            Key Takeaways
          </h3>
          <div className="space-y-4">
            {keyTakeaways.map((takeaway, idx) => (
              <div
                key={idx}
                className="card accent-border-left animate-fade-in-up"
                style={{ animationDelay: `${idx * 0.1}s` }}
              >
                <div className="flex items-start gap-3">
                  <div className="accent-text text-2xl font-bold">✓</div>
                  <p className="text-slate-700 dark:text-slate-300 leading-relaxed flex-1"
                     dangerouslySetInnerHTML={{ __html: inlineMarkdown(takeaway) }} />
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Bridge to next section */}
        {bridgeText && (
          <div className="accent-bg-lighter rounded-lg p-6 text-center animate-fade-in-up" style={{ animationDelay: '0.4s' }}>
            <p className="text-lg text-slate-700 dark:text-slate-300 leading-relaxed"
               dangerouslySetInnerHTML={{ __html: inlineMarkdown(bridgeText) }} />
          </div>
        )}
      </div>
    </div>
  );
}
